import React from 'react'
import styled from 'styled-components'

function PrivacyPolicy() {
  return (
     <Container>
            <h1>MarketLab Privacy Policy</h1>

<h2>Information We Collect</h2>
<p>
    MarketLab may collect personal information from users such as names, email addresses, and payment information when necessary for providing our services. We may also collect non-personal information such as browser type, IP address, and operating system for analytics and security purposes.
</p>

<h2>How We Use Your Information</h2>
<p>
    We use the information we collect to provide, maintain, and improve our services, to communicate with you, to process transactions, and to protect against fraud and abuse. We may also use your information to personalize your experience and to send you promotional messages and marketing communications.
</p>

<h2>Information Sharing</h2>
<p>
    MarketLab may share your personal information with third-party service providers, business partners, or affiliates who assist us in delivering our services. We may also share your information when required by law, to protect our rights or the rights of others, or to prevent harm.
</p>

<h2>Account Security</h2>
<p>
    You are responsible for maintaining the security of your account and for safeguarding your login credentials. Do not share your account information with others, and notify us immediately if you suspect unauthorized access to your account.
</p>

<h2>Children's Privacy</h2>
<p>
    MarketLab is not directed to children under the age of 13, and we do not knowingly collect personal information from children. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us immediately.
</p>

<h2>Changes to this Privacy Policy</h2>
<p>
    MarketLab reserves the right to update or modify this Privacy Policy at any time. We will notify you of any changes by posting the new Privacy Policy on this page. Your continued use of our services after any modifications indicate your acceptance of the updated Privacy Policy.
</p>

<h2>Contact Us</h2>
<p>
    If you have any questions or concerns about our Privacy Policy, please contact us at support@improwth.com or reach@improwth.com.
</p>

<div style={{height: '100px', marginBlock: '50px'}}/>
     </Container>
  )
}

export default PrivacyPolicy



const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: #f2f2f2;
    padding: 25px 0 0 15px;
    overflow-x: hidden;
    overflow-y: scroll;


    > h1 {
        font-weight: 300;
        margin-bottom: 50px;
    }

    > h2 {
        font-weight: 300;
        margin-bottom: 10px;
    }

    > p {
        width: 70%;
        margin-bottom: 20px;

        > ul > li {
            margin-left: 20px;
        }
    }
`